/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Toolbar_ResetInputs */

const id_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atur Ulang`)
};

const ms_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Semula`)
};

const da_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nulstil`)
};

const de_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurücksetzen`)
};

const en_us2_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const es_es2_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer`)
};

const es_mx2_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer`)
};

const fil_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-reset`)
};

const fr_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser`)
};

const it_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reimposta`)
};

const hu_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visszaállítás`)
};

const nl_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resetten`)
};

const no_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbakestill`)
};

const pl_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resetuj`)
};

const pt_br2_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const pt_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repor`)
};

const ro_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resetează`)
};

const fi_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nollaa`)
};

const sv_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Återställ`)
};

const vi_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt lại`)
};

const tr_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sıfırla`)
};

const cs_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const bg_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нулиране`)
};

const ru_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сбросить`)
};

const uk_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скинути`)
};

const ar_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة تعيين`)
};

const hi_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रीसेट`)
};

const th_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีเซ็ต`)
};

const ja_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リセット`)
};

const zh_cn2_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const zh_hant1_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const ko_table_toolbar_reset = /** @type {(inputs: Table_Toolbar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

/**
* | output |
* | --- |
* | "Reset" |
*
* @param {Table_Toolbar_ResetInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_toolbar_reset = /** @type {((inputs?: Table_Toolbar_ResetInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Toolbar_ResetInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_toolbar_reset(inputs)
	if (locale === "ms") return ms_table_toolbar_reset(inputs)
	if (locale === "da") return da_table_toolbar_reset(inputs)
	if (locale === "de") return de_table_toolbar_reset(inputs)
	if (locale === "en-US") return en_us2_table_toolbar_reset(inputs)
	if (locale === "es-ES") return es_es2_table_toolbar_reset(inputs)
	if (locale === "es-MX") return es_mx2_table_toolbar_reset(inputs)
	if (locale === "fil") return fil_table_toolbar_reset(inputs)
	if (locale === "fr") return fr_table_toolbar_reset(inputs)
	if (locale === "it") return it_table_toolbar_reset(inputs)
	if (locale === "hu") return hu_table_toolbar_reset(inputs)
	if (locale === "nl") return nl_table_toolbar_reset(inputs)
	if (locale === "no") return no_table_toolbar_reset(inputs)
	if (locale === "pl") return pl_table_toolbar_reset(inputs)
	if (locale === "pt-BR") return pt_br2_table_toolbar_reset(inputs)
	if (locale === "pt") return pt_table_toolbar_reset(inputs)
	if (locale === "ro") return ro_table_toolbar_reset(inputs)
	if (locale === "fi") return fi_table_toolbar_reset(inputs)
	if (locale === "sv") return sv_table_toolbar_reset(inputs)
	if (locale === "vi") return vi_table_toolbar_reset(inputs)
	if (locale === "tr") return tr_table_toolbar_reset(inputs)
	if (locale === "cs") return cs_table_toolbar_reset(inputs)
	if (locale === "bg") return bg_table_toolbar_reset(inputs)
	if (locale === "ru") return ru_table_toolbar_reset(inputs)
	if (locale === "uk") return uk_table_toolbar_reset(inputs)
	if (locale === "ar") return ar_table_toolbar_reset(inputs)
	if (locale === "hi") return hi_table_toolbar_reset(inputs)
	if (locale === "th") return th_table_toolbar_reset(inputs)
	if (locale === "ja") return ja_table_toolbar_reset(inputs)
	if (locale === "zh-CN") return zh_cn2_table_toolbar_reset(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_toolbar_reset(inputs)
	return ko_table_toolbar_reset(inputs)
});
export { table_toolbar_reset as "table.toolbar.reset" }